import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";

const GNBPURE00002S = () => {
  const { doAction } = useApplicationCommon(); // ✅ `doAction`만 사용
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태
  const [resDs, setResDs] = useState([]);
  const [coNo, setCoNo] = useState("1");

  // 최초 렌더링
  useEffect(() => {
    goSearch();
  }, [coNo]);

  const tapClick = (code) => {
    setCoNo(code);
  }

  // 사업실적 조회
  const goSearch = () => {
    const actionForm = {
      txGbnCd: "S01",
      coNo: coNo
    };

    doAction("COM0003SC", actionForm, (resDs) => {
      if (resDs.APP_HEADER.respCd == 'N00001') {
        setResDs(resDs.LIST);
      }
    })
  }

  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type01">
          <h2>기업소개</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>사업실적<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE00000S">CEO인사말</Link></li>
                <li><Link to="/GNBPURE00001S">ABOUT US</Link></li>
                <li><Link to="/GNBPURE03001S">우리회사소식</Link></li>
                <li><Link to="/GNBPURE00002S">사업실적</Link></li>
                <li><Link to="/GNBPURE00003S">오시는길</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            <h3>사업실적</h3>

            <div className="tabs ty02">
            <ul className="tab-item col03">
              <li className={coNo === "1" ? "on" : ""}>
                <Link to="/" onClick={(e) => { e.preventDefault(); tapClick("1"); }}>
                  Gnb소프텍
                </Link>
              </li>
              <li className={coNo === "2" ? "on" : ""}>
                <Link to="/" onClick={(e) => { e.preventDefault(); tapClick("2"); }}>
                  퓨어솔루션
                </Link>
              </li>
            </ul>

            </div>

            <article className="ContentWrap">
              <p className="subtitle txt-blue02">
              {coNo == "1" ? "2007" : "2017"}년부터 현재까지 <br />
                {coNo == "1" ? "(주)지앤비소프텍" : "(주)퓨어솔루션"}이 쌓은 발자국입니다.
              </p>
              <div className="busi-wrap" id="resultList">
                {resDs.map((item, i) => (
                  <ul key={i} className={i % 2 === 0 ? "list-style1" : "list-style2"}>
                    <li className={i % 2 === 0 ? "mr20" : "mr120"}>
                      <dl style={i % 2 === 0 ? { marginLeft: "20px" } : { marginRight: "20px" }}>
                        <dt>{item.aslt_yy}</dt>
                        <dd>{item.aslt_cntn.split("\n").map((line, index) => (
                           <React.Fragment key={index}>
                            {line}
                            <br />
                            </React.Fragment>
                        ))}</dd>
                      </dl>
                    </li>
                  </ul>
                ))}
              </div>
            </article>
          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE00002S;